module.exports = __webpack_public_path__ + "static/media/hackers_cyberdelia.41e501df.gif";